import { render, staticRenderFns } from "./BindsEmptyState.vue?vue&type=template&id=68f36526&"
import script from "./BindsEmptyState.vue?vue&type=script&lang=js&"
export * from "./BindsEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./BindsEmptyState.vue?vue&type=style&index=0&id=68f36526&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports